import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'prime-toast',
  templateUrl: './prime-toast.component.html',
  styleUrls: ['./prime-toast.component.scss']
})
export class PrimeToastComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
